import React, {useState} from "react";
import {Switch, FormControlLabel} from "@mui/material";

interface ToggleProps {
    onToggle: (isOn: boolean) => void;
    label: string;
    labelPlacement: "start" | "end" | "top" | "bottom";
    disabled?: boolean;
}

const Toggle: React.FC<ToggleProps> = ({onToggle, label, labelPlacement, disabled}) => {
    const [isOn, setIsOn] = useState(false);

    const handleToggle = () => {
        setIsOn(!isOn);
        onToggle(!isOn);
    };

    return (
        <FormControlLabel
            control={<Switch checked={isOn} onChange={handleToggle}/>}
            label={label}
            labelPlacement={labelPlacement}
            disabled={disabled}
        />
    )
};

export default Toggle;